import {
  TableContainer,
  TableBody,
  TableCell,
  Table,
  TableRow,
} from "@material-ui/core";
import { PencilIcon, TrashIcon } from "App/Assets";
import {
  TableHeader,
  IconButtonDatatable,
  DatatablesFooter,
  ModalDeleteConfirm,
} from "App/Component/ui";
import { instance4 } from "App/constants";
import { useDatatables } from "App/hooks";
import {
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
  formatRupiah,
} from "App/utils/helpers";
import React, { useState, useEffect, useContext } from "react";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { FormContext } from "./context/FormContext";
import moment from "moment";
// import { accessCode } from "utils/all";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";

export const urlCreatePO = LIST_URL_WAREHOUSE.purchaseOrderPBF.add;
export const urlUpdatePO = LIST_URL_WAREHOUSE.purchaseOrderPBF.update;
export const urlGetPoById = LIST_URL_WAREHOUSE.purchaseOrderPBF.getByPo;

export const urlGetBarangPoById =
  LIST_URL_WAREHOUSE.purchaseOrderPBF.getBarangPo;
export const urlCreateBarang = LIST_URL_WAREHOUSE.purchaseOrderPBF.addBarang;
export const urlDeleteBarang = LIST_URL_WAREHOUSE.purchaseOrderPBF.deleteBarang;
export const urlUpdateBarang = LIST_URL_WAREHOUSE.purchaseOrderPBF.updateBarang;
export const urlChangeStatus = LIST_URL_WAREHOUSE.purchaseOrderPBF.changeStatus;

export const urlGetGudang = LIST_URL_WAREHOUSE.masterGudangPBF.getGudang;

export const STATUS_OPEN_DRAFT = false;
export const STATUS_PROCESS = true;

export const STATUS_TRANSAKSI_PENGAJUAN = 1;
export const STATUS_TRANSAKSI_DISETUJUI = 2;
export const STATUS_TRANSAKSI_PENGADAAN = 3;
export const STATUS_TRANSAKSI_SELESAI = 4;

export const FORM_RESET_STATE_WMS_PO = {
  idpo: "",
  date: moment(new Date()).local().toDate(),
  noPO: "",

  gudang_id: null,
  gudang: "Pilih Gudang Farmasi",

  supplier_id: null,
  supplier: "Pilih Supplier",

  penerima: "",
  remark: "",

  type: "create",
  status: 0,

  isOpenDraf: false,
  isProcess: false,

  is_persentase_potongan: false,
  diskon_persen: 0,

  jumlah: 0,
  potongan: 0,
  potongan2: 0,
  tax: 0,
  total_jumlah: 0,
};

const getMasterGudangOnlyFarmasi = async (url) => {
  try {
    const api = await instance4.get(url);
    const res = api.data;
    return res.body;
  } catch (error) {
    return false;
  }
};

export const getPoById = async (id) => {
  try {
    const api = await instance4.get(`${urlGetPoById}/${id}`);
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data:
          res.data.length > 0
            ? res.data[0]
            : {
                totalTax: 0,
                jumlah: 0,
              },
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getPoListById = async (id) => {
  try {
    const api = await instance4.get(`${urlGetBarangPoById}/${id}`);
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const deletePoListById = async (id) => {
  try {
    const api = await instance4.post(urlDeleteBarang, {
      id,
    });
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res,
        message: "Berhasil menghapus po list",
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      data: {},
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    align: "left",
  },
  {
    id: "barang",
    disablePadding: false,
    label: "NAMA BARANG",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "satuan",
    disablePadding: false,
    label: "SATUAN",
    align: "left",
  },
  {
    id: "qty",
    disablePadding: false,
    label: "QTY",
    align: "left",
  },
  {
    id: "harga",
    disablePadding: false,
    label: "HARGA",
    align: "left",
  },
  {
    id: "disc",
    disablePadding: false,
    label: "DISC (%)",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "sub_jumlah",
    disablePadding: false,
    label: "SUB JUMLAH",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "nilai_disc",
    disablePadding: false,
    label: "NILAI DISC",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "jumlah",
    disablePadding: false,
    label: "JUMLAH",
    align: "left",
  },
];

export const useInitalGudangOnlyFarmasi = (
  url = LIST_URL_WAREHOUSE.masterGudangPBF.gudangOnlyFarmasi
) => {
  const [state, setState] = useState([]);
  useEffect(() => {
    (async () => {
      const res = await getMasterGudangOnlyFarmasi(url);
      if (res) {
        const data = [];
        res.map((item) => {
          return data.push({
            value: item.id,
            label: item.name,
          });
        });

        setState(data);
      }
    })();
  }, [url]);

  return state;
};

export const setPerhitungan = (formData, setFormData, row) => {
  return setFormData({
    ...formData,
    jumlah: row?.jumlah,
    tax: row?.tax,
    total_jumlah: row?.total_jumlah,
  });
};

export const RenderListPo = ({
  classes,
  listPO,
  formBarang,
  setFormBarang,
  showModalBarang,
  setShowModalBarang,
  setNewDataPoList,
}) => {
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  const {
    page,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: listPO,
    orderByDefault: "namaBarang",
    orderByRow: ["namaBarang"],
  });
  const { formData } = useContext(FormContext);

  async function deleteList() {
    const res = await deletePoListById(formBarang.id);
    if (res.state) {
      // setPerhitungan(formData, setFormData, res?.data?.perhitungan);
      defaultToastSuccess(res?.message);
      await setNewDataPoList(formData?.idpo);
      setShowModalDeleteConfirm(false);
    } else {
      defaultToastError(res?.message);
    }
  }

  const handleClickDelete = (row) => {
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
    setFormBarang({
      ...formBarang,
      id: row?.ItemPOId,
    });
  };

  const handleClickUpdate = async (row) => {
    await setFormBarang({
      id: row?.ItemPOId,
      barang_id: row.barang_id,
      satuan_id: row.satuan_id,
      satuan_name: row.namaSatuan,
      qty: row.qty,
      disc: row.disc,
      harga: row.harga,
      harga2: formatRupiah(row.harga),
    });
    setShowModalBarang(!showModalBarang);
  };

  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}
      <p className='fw-600 mb-1 mt-1'>Data Transaksi PO</p>
      <TableContainer className='custom-scrollbar'>
        <Table
          className={classes.table}
          aria-labelledby='tableTitle'
          size={"medium"}
          aria-label='enhanced table'>
          <TableHeader
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={length}
            headCells={headCells}
          />
          <TableBody>
            {stableSort(data, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                    }}>
                    <TableCell
                      component='th'
                      scope='row'
                      padding='none'
                      align='center'>
                      {index + 1}
                    </TableCell>

                    <TableCell
                      component='th'
                      scope='row'
                      padding='none'
                      align='center'>
                      {!formData.isProcess && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "7px",
                          }}>
                          <IconButtonDatatable
                            onClick={() => handleClickUpdate(row)}>
                            <PencilIcon />
                          </IconButtonDatatable>

                          <IconButtonDatatable
                            onClick={() => handleClickDelete(row)}>
                            <TrashIcon />
                          </IconButtonDatatable>
                        </div>
                      )}
                    </TableCell>

                    <RenderTableCell row={row} />
                  </TableRow>
                );
              })}
            {listPO.length === 0 && (
              <TableRow>
                <TableCell align='center' colSpan={headCells.length}>
                  Tidak ada data
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <DatatablesFooter
        page={page}
        length={length}
        rowsPerPage={rowsPerPage}
        selectRows={[10, 20]}
        onPageChange={(page) => setPage(page - 1)}
        onSelectChange={(e) => setRowsPerPage(e.target.value)}
      />
    </>
  );
};

const RenderTableCell = ({ row }) => {
  const harga_x_qty = row.harga * row.qty;
  const nilaiDisc = (row.disc / 100) * harga_x_qty;
  const jumlah = harga_x_qty - nilaiDisc;
  return (
    <>
      <TableCell align='left'>{row.ItemPOId}</TableCell>
      <TableCell align='left'>{row.namaBarang}</TableCell>
      <TableCell align='left'>{row.namaSatuan}</TableCell>
      <TableCell align='left'>{row.qty}</TableCell>
      <TableCell align='left'>{formatNumber(row.harga)}</TableCell>
      <TableCell align='left'>{row.disc}</TableCell>
      <TableCell align='left'>{formatNumber(harga_x_qty)}</TableCell>
      <TableCell align='left'>{formatNumber(nilaiDisc)}</TableCell>
      <TableCell align='left'>{formatNumber(jumlah)}</TableCell>
    </>
  );
};
